// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CiCircleFilledSvg from "@ant-design/icons-svg/es/asn/CiCircleFilled";
import AntdIcon from '../components/AntdIcon';

var CiCircleFilled = function CiCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CiCircleFilledSvg
  }));
};

CiCircleFilled.displayName = 'CiCircleFilled';
export default React.forwardRef(CiCircleFilled);